import { Tool } from './Tool'
import { Draw } from 'ol/interaction'
import GeometryType from 'ol/geom/GeometryType'
import Feature from 'ol/Feature'
import LineString from 'ol/geom/LineString'
import VectorSource from 'ol/source/Vector'
import { ScaleInfo, UnitType } from '@/modules/viewerModule/viewer/Viewer.models'
import Geometry from 'ol/geom/Geometry'

export default class MeasureScaleTool extends Tool {
    private measureInteraction!: Draw;

    public removeInteractions(): void {
        if (this.measureInteraction) { this.state.map?.removeInteraction(this.measureInteraction) }
    }

    public addInteractions(): void {
        this.measureInteraction = new Draw({
            source: this.state.vectorSource as VectorSource<Geometry>,
            type: GeometryType.LINE_STRING,
            condition: this.manageClickEvent
        })

        this.state.map?.addInteraction(this.measureInteraction)

        this.measureInteraction.on('drawend', (evt) => {
            this.annotationManager.applyAnnotationDetails(evt.feature, false)
            const lineString = (<Feature<LineString>>evt.feature).getGeometry()
            this.annotationManager.askScale(<Feature < LineString >>evt.feature).then((scaleInfo) => {
                if (lineString) {
                    const geometryLenght: number = lineString.getLength()
                    const relation = this.normalizeScaleToMillimeters(scaleInfo) / geometryLenght
                    this.state.imageInfo.scale = relation
                    this.annotationManager.saveCurrentMeasureScale()
                    this.state.vectorSource?.removeFeature(evt.feature)
                    this.annotationManager.recalculateAllAreasAndDistances(true)
                }
            }, () => {
                this.state.vectorSource?.removeFeature(evt.feature)
            })
        })
    }

    private normalizeScaleToMillimeters(scaleInfo: ScaleInfo): number {
        switch (scaleInfo.unit) {
        case UnitType.M:
            return scaleInfo.scale * 1000
        case UnitType.CM:
            return scaleInfo.scale * 10
        case UnitType.MM:
            return scaleInfo.scale
        case UnitType.MICRAS:
            return scaleInfo.scale / 10
        case UnitType.NM:
            return scaleInfo.scale / 100
        }
        return 0
    }
}
